import { useState } from "react";
import emailjs from "emailjs-com";
import "./Appointment.css"; // reuse same style
import Header from "../../components/Header/Header";

function DoctorReferral() {
  const [formData, setFormData] = useState({
    doctorName: "",
    clinic: "",
    doctorEmail: "",
    doctorPhone: "",
    licenseNumber: "",

    clientName: "",
    clientAge: "",
    clientContact: "",

    referralReason: "",
    urgency: "",
    consent: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const sendReferral = (e) => {
    e.preventDefault();

    if (!formData.consent) {
      alert("Consent is required to submit a referral.");
      return;
    }

    emailjs
      .send(
        "service_jxqgorq",          // same service
        "template_6vnfx0m", // 👈 new template
        formData,
        "V4DSqKwwqaNwNPIGG"
      )
      .then(
        () => {
          alert("Referral submitted successfully.");
        },
        () => {
          alert("Failed to submit referral. Please try again.");
        }
      );
  };

  return (
    <>
      <Header />
      <div className="appointment-container">
        <h1 className="title">Professional Referral Form</h1>
        <p className="subtitle">
          This secure form is for healthcare professionals to submit client referrals.
          Our team will review and contact the family directly.
        </p>

        <form className="form-box" onSubmit={sendReferral}>

          {/* ================= Doctor Info ================= */}
          <h3 style={{ marginBottom: "15px" }}>Referring Professional</h3>

          <div className="form-row">
            <div className="form-group">
              <label>Doctor Name *</label>
              <input
                type="text"
                name="doctorName"
                value={formData.doctorName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Clinic / Organization</label>
              <input
                type="text"
                name="clinic"
                value={formData.clinic}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Email *</label>
              <input
                type="email"
                name="doctorEmail"
                value={formData.doctorEmail}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Phone</label>
              <input
                type="text"
                name="doctorPhone"
                value={formData.doctorPhone}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-group">
            <label>License Number (optional)</label>
            <input
              type="text"
              name="licenseNumber"
              value={formData.licenseNumber}
              onChange={handleChange}
            />
          </div>

          {/* ================= Client Info ================= */}
          <h3 style={{ margin: "25px 0 15px" }}>Client Information</h3>

          <div className="form-row">
            <div className="form-group">
              <label>Client Name *</label>
              <input
                type="text"
                name="clientName"
                value={formData.clientName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Client Age</label>
              <input
                type="text"
                name="clientAge"
                value={formData.clientAge}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-group">
            <label>Client / Guardian Contact *</label>
            <input
              type="text"
              name="clientContact"
              value={formData.clientContact}
              onChange={handleChange}
              required
            />
          </div>

          {/* ================= Referral Details ================= */}
          <div className="form-group">
            <label>Reason for Referral *</label>
            <textarea
              name="referralReason"
              rows="4"
              value={formData.referralReason}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Urgency Level</label>
            <select
              name="urgency"
              value={formData.urgency}
              onChange={handleChange}
            >
              <option value="">Please select</option>
              <option>Low</option>
              <option>Medium</option>
              <option>High</option>
            </select>
          </div>

          {/* ================= Consent ================= */}
          <div className="consent-box">
            <label className="checkbox-container">
              <input
                type="checkbox"
                name="consent"
                checked={formData.consent}
                onChange={handleChange}
              />
              I confirm I have obtained client consent to submit this referral.
            </label>
          </div>

          <button className="submit-btn" type="submit">
            Submit Referral →
          </button>

        </form>
      </div>
    </>
  );
}

export default DoctorReferral;
